import { render } from "./CarpetBackground.vue?vue&type=template&id=584104ce&scoped=true"
import script from "./CarpetBackground.vue?vue&type=script&lang=js"
export * from "./CarpetBackground.vue?vue&type=script&lang=js"

import "./CarpetBackground.vue?vue&type=style&index=0&id=584104ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584104ce"]])

export default __exports__